import { v4 as uuidV4 } from 'uuid';
import { useBuildVars, useSiteConfig } from '../config';
import {
  getAuthorizationHeader,
  useDecodedToken,
} from '../auth/authorization.hook';
import { useLocalizationContext } from '@im/react-localization';

export type ExtraHeaders = Partial<{
  [headerName: string]: string;
}>;

const win = window as any;
const temp_session_Id = uuidV4(); // used if datadog session id is not available

const appIdMap: {
  [key: string]: {
    microfrontendId: string;
    senderId: string;
  };
} = {
  cep: {
    microfrontendId: 'cep_app',
    senderId: 'IMCEP',
  },
  x4ec: {
    microfrontendId: 'x4ec_app',
    senderId: 'IMX4EC',
  },
};

export function useApiHeaders(
  isLoggedOutMode = false,
  isEncodedParams = false
) {
  const siteConfig = useSiteConfig();
  const buildConfig = useBuildVars();
  const decodedToken = useDecodedToken();
  const l10nContext = useLocalizationContext();

  return (extraHeaders?: ExtraHeaders) => {
    const authorization = getAuthorizationHeader();
    const correlationId = uuidV4();
    const { locale } = l10nContext;
    const [, countryCode] = locale.split('-');
    const { environment, siteCode } = siteConfig;

    const resellerId = decodedToken?.resellerId || '';
    const userId = decodedToken?.userId || '';
    const dd_session_id =
      win.DD_RUM?.getInternalContext()?.session_id || temp_session_Id;

    const appIdSpecificHeaders = appIdMap[buildConfig.appId || 'cep'];

    const headers = {
      // New APIs Headers
      'IM-AcceptLanguage': locale, // en-US [deprecated-soon]
      'IM-CorrelationID': correlationId,
      'IM-CountryCode': countryCode, // US
      'IM-CustomerNumber': resellerId,
      'IM-DDSessionId': dd_session_id, // session_id used for throttling rate limit for no-auth
      'IM-Environment': environment, // [deprecated-soon]
      'IM-MicroFrontendID': appIdSpecificHeaders.microfrontendId,
      'IM-ResellerID': resellerId,
      'IM-SenderID': appIdSpecificHeaders.senderId,
      'IM-SiteCode': siteCode,
      'IM-UserID': userId,

      accept: 'application/json',
      'accept-language': locale, // en-US
      authorization,
      'content-type': 'application/json',

      // Old APIs Headers
      correlationId,
      countryCode, // US
      customerNumber: resellerId,
      distributionChannel: decodedToken?.imoProfile.distributionChannel,
      division: decodedToken?.imoProfile.division,
      isoCountryCode: countryCode, // US
      ...extraHeaders,
    } as { [headerName: string]: string };

    if (isLoggedOutMode) {
      headers['IM-ApiKey'] = buildConfig['API_KEY'];
    }
    if (isEncodedParams) {
      headers['Decodeurl'] = 'true';
    }
    return headers;
  };
}
